import { relations } from 'drizzle-orm'
import { index, pgTable, text, unique } from 'drizzle-orm/pg-core'
import { getBaseFields, getBaseIndexes, getIdReference } from '../common/utils'
import { refreshTokens } from './auth'

export const pushSubscriptions = pgTable(
  'push_subscriptions',
  {
    ...getBaseFields(),
    // Link to the initial token of the refresh token chain
    // When the chain is revoked (logout), all push subscriptions are deleted,
    // to avoid sending push notifications to old sessions.
    initialTokenId: getIdReference(() => refreshTokens.id),
    endpoint: text().notNull(),
    p256dhKey: text().notNull(),
    authKey: text().notNull(),
  },
  (table) => [
    ...getBaseIndexes('push_subscriptions', table),
    index('push_subscriptions_initial_token_id_idx').on(table.initialTokenId),
    // Unique constraint: one subscription per endpoint per session
    unique('push_subscriptions_token_endpoint_unique').on(
      table.initialTokenId,
      table.endpoint,
    ),
  ],
)

export const pushSubscriptionsRelations = relations(
  pushSubscriptions,
  ({ one }) => ({
    refreshToken: one(refreshTokens, {
      fields: [pushSubscriptions.initialTokenId],
      references: [refreshTokens.id],
    }),
  }),
)
